import React from 'react';

function Locked({ size }) {
  return (
    <svg height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.6 8.4V7.6C17.6 6.11479 17.01 4.69041 15.9598 3.6402C14.9096 2.59 13.4852 2 12 2C10.5148 2 9.09041 2.59 8.0402 3.6402C6.99 4.69041 6.4 6.11479 6.4 7.6V8.4H4V18.8C4 19.4365 4.25286 20.047 4.70294 20.4971C5.15303 20.9471 5.76348 21.2 6.4 21.2H17.6C18.2365 21.2 18.847 20.9471 19.2971 20.4971C19.7471 20.047 20 19.4365 20 18.8V8.4H17.6ZM8 7.6C8 6.53913 8.42143 5.52172 9.17157 4.77157C9.92172 4.02143 10.9391 3.6 12 3.6C13.0609 3.6 14.0783 4.02143 14.8284 4.77157C15.5786 5.52172 16 6.53913 16 7.6V8.4H8V7.6ZM18.4 18.8C18.4 19.0122 18.3157 19.2157 18.1657 19.3657C18.0157 19.5157 17.8122 19.6 17.6 19.6H6.4C6.18783 19.6 5.98434 19.5157 5.83431 19.3657C5.68429 19.2157 5.6 19.0122 5.6 18.8V10H18.4V18.8Z"
        fill="currentColor"
      />
      <path d="M12.8002 13.2H11.2002V16.3999H12.8002V13.2Z" fill="currentColor" />
    </svg>
  );
}

export default Locked;
